export default __webpack_public_path__ + "static/media/client.2236deb4.jpg";